import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoDynamicModule, PoGridModule, PoModalModule, PoFieldModule, PoTableModule, PoToolbarModule, PoDialogModule, PoMenuModule, PoButtonModule, PoButtonGroupModule } from '@po-ui/ng-components';
import { PaginationComponent } from 'src/app/shared/pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalFilterComponent } from './modal-filter/modal-filter.component';


@NgModule({
    declarations: [
        PaginationComponent,
        ModalFilterComponent
    ],
    imports: [
        CommonModule,
        PoGridModule,
        PoDynamicModule,
        PoModalModule,
        FormsModule,
        ReactiveFormsModule,
        PoFieldModule,
        PoTableModule,
        PoToolbarModule,
        PoDialogModule,
        PoMenuModule,
        PoButtonModule,
        PoButtonGroupModule,
    ],
    exports: [
        PaginationComponent,
        ModalFilterComponent
    ]
})
export class SharedModule { }
